import { render, staticRenderFns } from "./VideoIdTable.vue?vue&type=template&id=5a2bf956&scoped=true&"
import script from "./VideoIdTable.vue?vue&type=script&lang=ts&"
export * from "./VideoIdTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2bf956",
  null
  
)

export default component.exports